export const GET_USER_REWARDS_ACCOUNTS = '/v1/rewards-user-accounts';
